import { createFileRoute } from '@tanstack/react-router'
import CheckoutSuccessPage from '@/spa/pages/CheckoutSuccessPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/checkout/success')({
  component: CheckoutSuccessPage,
  errorComponent: routeErrorComponent,
})
